import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import * as styles from "./Auth.module.css";
import {
  useVerifyTelegramMutation,
  useResendTelegramMutation,
} from "../../redux/services/telegram";

const BOT_NICKNAME = process.env.TELEGRAM_BOT_NICKNAME || "DwtlLoginBot";

const OTPModal = ({
  startToken,
  onUpdateStartToken,
  startError,
  onClose,
  onSuccess,
}) => {
  const [otp, setOtp] = useState("");
  const [remaining, setRemaining] = useState(120);
  const [error, setError] = useState(null);
  const [mustResend, setMustResend] = useState(false);
  const [verifyTelegram, { isLoading: verifying }] =
    useVerifyTelegramMutation();
  const [resendTelegram, { isLoading: resending }] =
    useResendTelegramMutation();

  useEffect(() => {
    setRemaining(120);
    const t = setInterval(() => {
      setRemaining((r) => {
        if (r <= 1) {
          clearInterval(t);
          return 0;
        }
        return r - 1;
      });
    }, 1000);
    return () => clearInterval(t);
  }, [startToken]);

  const verify = async () => {
    setError(null);
    try {
      const data = await verifyTelegram({
        start_token: startToken,
        otp,
      }).unwrap();
      onSuccess(data);
    } catch (e) {
      const msg = e.data?.message || e.message || "Verification failed";
      if (msg === "invalid_otp") {
        setError(
          "Invalid or expired code. Please request a new code (Resend).",
        );
        setMustResend(true);
      } else {
        setError(msg);
      }
    }
  };

  const resend = async () => {
    setError(null);
    try {
      const data = await resendTelegram({ start_token: startToken }).unwrap();
      const id = data.start_token || data.startToken || startToken;
      if (onUpdateStartToken && id) onUpdateStartToken(id);
      window.open(
        `https://t.me/${BOT_NICKNAME}?start=${encodeURIComponent(id)}`,
        "_blank",
        "noopener,noreferrer",
      );
      setRemaining(120);
      setOtp("");
      setMustResend(false);
    } catch (e) {
      setError(e.data?.message || e.message || "Resend failed");
    }
  };

  const loading = verifying || resending;

  return (
    <Dialog
      header="One Time Password"
      visible={true}
      onHide={onClose}
      modal
      className={styles.otpModal}
    >
      <p className={styles.otpModalText}>
        Enter the code you received in Telegram.
      </p>

      <div className={styles.uploadContent}>
        <InputText
          className={styles.input}
          type="text"
          inputMode="numeric"
          maxLength={6}
          value={otp}
          onChange={(e) => setOtp(e.target.value.replace(/[^0-9]/g, ""))}
          placeholder="123456"
        />

        <div style={{ display: "flex", gap: 8, width: "100%" }}>
          <Button
            label="Verify"
            className={styles.otpModalBtnVerify}
            onClick={verify}
            disabled={loading || otp.length < 4 || mustResend}
            loading={verifying}
          />
          <Button
            label="Cancel"
            className={styles.otpModalBtnCancel}
            onClick={onClose}
            disabled={loading}
          />
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
          }}
        >
          <div className={styles.otpModalTextContent}>
            Code expires in: {remaining}s
          </div>
          <a
            label="Resend"
            className={styles.otpModalBtnResend}
            onClick={resend}
            disabled={loading || remaining > 0}
            loading={resending}
          >
            Resend
          </a>
        </div>

        {startError && (
          <div style={{ color: "#c62828", marginTop: 8 }}>{startError}</div>
        )}
        {error && <div style={{ color: "#c62828", marginTop: 8 }}>{error}</div>}
      </div>
    </Dialog>
  );
};

export default OTPModal;
